<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    :aria-labelledby="'registrations_' + modalId"
    aria-hidden="true"
    :data-backdrop="currentStep > 1 ? 'static' : true"
    :data-keyboard="currentStep === 1 ? true : false"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      :class="currentStep === 1 ? 'modal-xl' : 'modal-md'"
      style="height:fit-content !important"
    >
      <div class="modal-content">
        <div class="modal-header bg-spnm text-white">
          <h6 class="modal-title">
            <i class="fas fa-envelope mr-2"></i>
            <span v-if="currentStep === 1">User List – Select Recipients</span>
            <span v-if="currentStep === 2">Confirm Invitation Subject</span>
            <span v-if="currentStep === 3">Sending Invitations...</span>
            <span v-if="currentStep === 4">Invitation Results</span>
          </h6>
          <button
            type="button"
            class="close text-white"
            :data-dismiss="currentStep === 3 ? '' : 'modal'"
            @click="handleClose"
            :disabled="currentStep === 3"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Step 1: User List -->
        <div v-if="currentStep === 1">
          <div class="modal-body">
            <CoreDatatable
              v-if="tableData.tableHeaders != null"
              :dataBase="tableData.dataBase"
              :tableHeaders="tableData.tableHeaders"
              :title="'User List'"
              :dynamicTableId="dataTableID"
              @onTableReady="enableDatatableFeatures()"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancel</button>
            <button
              type="button"
              class="btn btn-spnm btn-sm"
              :disabled="mailToSend.length === 0"
              @click="currentStep = 2"
            >
              <i class="fas fa-arrow-right mr-1"></i> Next ({{ mailToSend.length }} selected)
            </button>
          </div>
        </div>

        <!-- Step 2: Confirm Subject -->
        <div v-if="currentStep === 2">
          <div class="modal-body">
            <p class="text-muted" style="font-size:0.85rem;">
              Sending invitations to <strong>{{ mailToSend.length }}</strong> user(s).
            </p>
            <div class="form-group">
              <label class="font-weight-bold">Email Subject</label>
              <input type="text" class="form-control form-control-sm" v-model="emailSubject" placeholder="Email subject" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" @click="currentStep = 1">Back</button>
            <button type="button" class="btn btn-spnm btn-sm" @click="startSendInvite" :disabled="!emailSubject.trim()">
              <i class="fas fa-paper-plane mr-1"></i> Send to {{ mailToSend.length }} user(s)
            </button>
          </div>
        </div>

        <!-- Step 3: Progress -->
        <div v-if="currentStep === 3">
          <div class="modal-body text-center py-4">
            <i class="fas fa-envelope fa-2x text-primary mb-2"></i>
            <h6>Sending invitations, please wait...</h6>
            <div class="progress mb-2" style="height:22px;border-radius:11px;">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                :style="{ width: inviteProgress + '%' }"
              >{{ inviteProgress }}%</div>
            </div>
            <div class="d-flex justify-content-between px-1" style="font-size:0.8rem;">
              <span>{{ inviteJob.processed }} / {{ inviteJob.total }} processed</span>
              <span>
                <span class="text-success font-weight-bold">{{ inviteJob.succeeded }} sent</span>
                &bull;
                <span class="text-danger font-weight-bold">{{ inviteJob.failed }} failed</span>
              </span>
            </div>
          </div>
          <div class="modal-footer"><small class="text-muted"><i class="fas fa-lock mr-1"></i>Please wait...</small></div>
        </div>

        <!-- Step 4: Results -->
        <div v-if="currentStep === 4">
          <div class="modal-body">
            <div class="d-flex justify-content-center mb-3">
              <div class="invite-result-badge invite-result-success mr-3">
                <i class="fas fa-check-circle fa-2x"></i>
                <div class="font-weight-bold" style="font-size:1.3rem;">{{ inviteJob.succeeded }}</div>
                <div style="font-size:0.75rem;">Sent</div>
              </div>
              <div class="invite-result-badge invite-result-danger">
                <i class="fas fa-times-circle fa-2x"></i>
                <div class="font-weight-bold" style="font-size:1.3rem;">{{ inviteJob.failed }}</div>
                <div style="font-size:0.75rem;">Failed</div>
              </div>
            </div>
            <div v-if="inviteJob.failed > 0">
              <div class="d-flex justify-content-between mb-1">
                <span class="font-weight-bold text-danger"><i class="fas fa-exclamation-triangle mr-1"></i>Failed</span>
                <button class="btn btn-outline-secondary btn-sm" @click="downloadFailed"><i class="fas fa-download mr-1"></i>CSV</button>
              </div>
              <div style="max-height:180px;overflow-y:auto;">
                <table class="table table-sm table-bordered">
                  <thead class="thead-light"><tr><th>#</th><th>Name</th><th>Email</th><th>Error</th></tr></thead>
                  <tbody>
                    <tr v-for="(e, i) in inviteJob.failedEntries" :key="i">
                      <td>{{ i+1 }}</td><td>{{ e.name }}</td><td>{{ e.email }}</td>
                      <td class="text-danger" style="font-size:0.75rem;">{{ e.error }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="text-success text-center"><i class="fas fa-check-circle fa-lg mr-1"></i>All invitations sent successfully!</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-spnm btn-sm" @click="handleClose"><i class="fas fa-times mr-1"></i>Close</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
  
<script>
import CoreDatatable from "../Core/Datatable.vue";
import $ from "jquery";
import axios from "axios";

var table;
var databaseLength = 0;

export default {
  name: "EventInviteList",
  props: ["eventInfo", "modalId"],
  components: {
    CoreDatatable,
  },
  data() {
    return {
      dataTableID: "UserListTable",
      mailToSend: [],
      tableData: {
        dataBase: [],
        tableHeaders: null,
        title: "User List",
      },
      currentStep: 1,
      emailSubject: "",
      inviteJob: { total: 0, processed: 0, succeeded: 0, failed: 0, failedEntries: [] },
      inviteJobId: null,
      invitePollTimer: null,
    };
  },
  computed: {
    inviteProgress() {
      if (!this.inviteJob.total) return 0;
      return Math.round((this.inviteJob.processed / this.inviteJob.total) * 100);
    },
  },
  created() {
    this.getDataBase();
    this.dataTableID = "UserListTable" + this.eventInfo.eventId;
    this.emailSubject = "SPNM Event Invitation: " + (this.eventInfo.title || "");
  },
  mounted() {},
  methods: {
    getDataBase() {
      var requestBody = {};
      var _this = this;
      axios
        .post("/api/User/UserList", requestBody)
        .then(function (response) {
          databaseLength = response.data.length;
          _this.generateTable(response.data);
        })
        .catch(function (error) {
          if (error.response) { console.log(error.response); } else { console.log(error); }
        });
    },

    generateTable(dataBase) {
      var tableHeaders = [
        {
          title: '<input type="checkbox" class=" mt-0 ml-0 invite-select-all" id="inviteSelectAll"> ',
          data: "userId",
          className: "dt-left",
          orderable: false,
          render: function () {
            return '<input type="checkbox" class="form-check-input ml-1 select-checkBox" id="selectCheckbox">';
          },
        },
        { title: "Membership No.", data: "membershipNo", className: "dt-left" },
        {
          title: "Membership Status", data: "membershipStatus", className: "dt-center",
          render: function (data) {
            return data == "Active"
              ? '<span class="badge badge-success">Active</span>'
              : '<span class="badge badge-danger">InActive</span>';
          },
        },
        { title: "First Name", className: "dt-left", data: "firstName" },
        { title: "Last Name", className: "dt-left", data: "lastName" },
        { title: "Company Name", className: "dt-left", data: "companyName" },
        { title: "Job Title", className: "dt-left", data: "jobTitle" },
        { title: "Personal Mail ID", className: "dt-left", data: "personalEmailId" },
        { title: "Contact Number", className: "dt-left", data: "personalMobileNo" },
      ];
      this.tableData.tableHeaders = tableHeaders;
      this.tableData.dataBase = dataBase;
    },

    enableDatatableFeatures() {
      table = $("#dashboardTable" + this.dataTableID).DataTable();
      var _this = this;
      $("#dashboardTable" + this.dataTableID + " tbody").on("click", "input.select-checkBox", function () {
        var rowdata = table.row($(this).parents("tr")).data();
        let obj = _this.mailToSend.find((o) => o.userId === rowdata.userId);
        if (obj) {
          _this.mailToSend.splice(_this.mailToSend.findIndex((a) => a.userId === rowdata.userId), 1);
        } else {
          _this.mailToSend.push(rowdata);
        }
        if (_this.mailToSend.length == databaseLength) {
          _this.mailToSend = _this.tableData.dataBase;
          $(".invite-select-all").prop("checked", true);
        } else {
          $(".invite-select-all").prop("checked", false);
        }
      });
      $("#dashboardTable" + this.dataTableID + " thead").on("click", "input.invite-select-all", function () {
        if (_this.mailToSend.length != parseInt(databaseLength)) {
          _this.mailToSend = _this.tableData.dataBase;
          $(".select-checkBox").prop("checked", true);
        } else {
          _this.mailToSend = [];
          $(".select-checkBox").prop("checked", false);
        }
      });
    },

    startSendInvite() {
      this.currentStep = 3;
      this.inviteJob = { total: this.mailToSend.length, processed: 0, succeeded: 0, failed: 0, failedEntries: [] };
      var _this = this;
      axios
        .post("/api/Event/InviteForEvent", {
          eventId: this.eventInfo.eventId,
          UserInformation: this.mailToSend,
          Subject: this.emailSubject,
        })
        .then(function (response) {
          _this.inviteJobId = response.data.jobId;
          _this.invitePollTimer = setInterval(_this.pollInviteProgress, 2000);
        })
        .catch(function (error) {
          _this.currentStep = 2;
          alert("Failed to start: " + (error.response ? error.response.data : error.message));
        });
    },

    pollInviteProgress() {
      var _this = this;
      axios
        .get("/api/BulkMail/Progress/" + this.inviteJobId)
        .then(function (response) {
          var d = response.data;
          _this.inviteJob = { total: d.total, processed: d.processed, succeeded: d.succeeded, failed: d.failed, failedEntries: d.failedEntries || [] };
          if (d.status === "completed" || d.status === "failed") {
            clearInterval(_this.invitePollTimer);
            _this.invitePollTimer = null;
            _this.currentStep = 4;
          }
        })
        .catch(function () {
          clearInterval(_this.invitePollTimer);
          _this.invitePollTimer = null;
          _this.currentStep = 4;
        });
    },

    handleClose() {
      if (this.currentStep === 3) return;
      this.currentStep = 1;
      this.mailToSend = [];
      this.inviteJobId = null;
      this.inviteJob = { total: 0, processed: 0, succeeded: 0, failed: 0, failedEntries: [] };
      this.emailSubject = "SPNM Event Invitation: " + (this.eventInfo.title || "");
      if (this.invitePollTimer) { clearInterval(this.invitePollTimer); this.invitePollTimer = null; }
      $("#" + this.modalId).modal("hide");
    },

    downloadFailed() {
      const rows = [["Name", "Email", "Error"]].concat(
        this.inviteJob.failedEntries.map(e => [e.name, e.email, e.error])
      );
      const csv = rows.map(r => r.map(c => '"' + String(c).replace(/"/g, '""') + '"').join(",")).join("\n");
      const a = document.createElement("a");
      a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
      a.download = "invite_failed.csv";
      a.click();
    },
  },
};
</script>

<style scoped>
.invite-result-badge {
  display: flex; flex-direction: column; align-items: center;
  padding: 12px 24px; border-radius: 10px;
}
.invite-result-success { background: #d4edda; color: #155724; }
.invite-result-danger  { background: #f8d7da; color: #721c24; }
</style>
